/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown>, label: NonNullable<unknown> }} Today_Day_SessionInputs */

const en_us2_today_day_session = /** @type {(inputs: Today_Day_SessionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} · Workout ${i?.label}`)
};

const pt_br2_today_day_session = /** @type {(inputs: Today_Day_SessionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} · Treino ${i?.label}`)
};

const es_419_today_day_session = /** @type {(inputs: Today_Day_SessionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} · Entrenamiento ${i?.label}`)
};

const pt_pt2_today_day_session = /** @type {(inputs: Today_Day_SessionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} · Treino ${i?.label}`)
};

const fr_fr2_today_day_session = /** @type {(inputs: Today_Day_SessionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} · Séance ${i?.label}`)
};

const de_de2_today_day_session = /** @type {(inputs: Today_Day_SessionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} · Training ${i?.label}`)
};

const it_it2_today_day_session = /** @type {(inputs: Today_Day_SessionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} · Allenamento ${i?.label}`)
};

/**
* | output |
* | --- |
* | "{day} · Workout {label}" |
*
* @param {Today_Day_SessionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_day_session = /** @type {((inputs: Today_Day_SessionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Day_SessionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_day_session(inputs)
	if (locale === "es-419") return es_419_today_day_session(inputs)
	if (locale === "pt-PT") return pt_pt2_today_day_session(inputs)
	if (locale === "fr-FR") return fr_fr2_today_day_session(inputs)
	if (locale === "de-DE") return de_de2_today_day_session(inputs)
	if (locale === "it-IT") return it_it2_today_day_session(inputs)
	return en_us2_today_day_session(inputs)
});
export { today_day_session as "today.day_session" }